import { useEnderecos } from '@/api/queries/empresa';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { MapPin, ExternalLink } from 'lucide-react';
import type { Endereco } from '@/api/types';

function mapsUrl(e: Endereco): string {
  if (e.latitude !== undefined && e.longitude !== undefined) {
    return `https://www.google.com/maps?q=${e.latitude},${e.longitude}`;
  }
  const parts = [e.rua, e.numero, e.bairro, e.cidade, e.estado, e.cep].filter(Boolean);
  return `https://www.google.com/maps/search/${encodeURIComponent(parts.join(', '))}`;
}

export function TabEnderecos({ empresaId }: { empresaId: string }) {
  const { data, isLoading } = useEnderecos(empresaId);
  if (isLoading) return <Skeleton className="h-32 mt-4" />;
  if (!data || data.length === 0) {
    return <p className="text-muted-foreground mt-4">Sem endereços cadastrados.</p>;
  }
  return (
    <div className="grid gap-3 mt-4">
      {data.map((e) => (
        <Card key={e.id} className="p-4">
          <div className="flex items-start justify-between gap-3">
            <div className="space-y-1">
              <Badge variant="outline" className="mb-1">
                {e.tipo}
              </Badge>
              <p className="text-sm">
                {[e.rua, e.numero, e.complemento].filter(Boolean).join(', ')}
                {e.bairro ? ` — ${e.bairro}` : ''}
              </p>
              <p className="text-sm text-muted-foreground">
                {[e.cidade, e.estado, e.cep].filter(Boolean).join(' · ')}
              </p>
            </div>
            <a
              href={mapsUrl(e)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-md border bg-card px-2.5 py-1.5 text-sm hover:bg-muted"
              title="Abrir no Google Maps"
            >
              <MapPin className="h-3.5 w-3.5" />
              <span>Maps</span>
              <ExternalLink className="h-3 w-3 text-muted-foreground" />
            </a>
          </div>
        </Card>
      ))}
    </div>
  );
}
